/**
 * Where the hosted MCP server lives: https://steampeek.app/mcp. Its route is
 * app/mcp/route.ts (paths.test.ts checks the two agree). Client-safe, so the
 * dashboard's snippets and the docs read the same value. Moving it breaks
 * every client already configured with it.
 */
export const MCP_PATH = "/mcp";
